<template>
	<div :class="['error-state error-state--' + color]">
		<img
			:src="require('../../assets/svg-icons/compass.svg')"
			class="error-state__image"
			alt=""
			aria-hidden="true"
		/>
		<slot>
			<p class="error-state__message">{{ message }}</p>
		</slot>
	</div>
</template>

<script>
/**
 * This component can be used to display an error message if a table or chart is not available. You can pass it a custom message or set the backgrond color to white or gray (defaults to gray).
 */
export default {
	name: "ErrorState",
	props: {
		/**
		 * Message text string.
		 */
		message: {
			type: String,
			default: "We’re having trouble locating this data, try again later."
		},

		/**
		 * Background color name.
		 * @values gray, white
		 */
		color: {
			type: String,
			default: "gray"
		}
	}
};
</script>

<style lang="scss">
.error-state {
	background-color: $color--white;
	margin-top: 20px;
	padding: 85px 40px;
	text-align: center;

	&--gray {
		background-color: $color--bg-gray;
	}

	&--white {
		background-color: $color--white;
	}

	@include from-md {
		padding: 170px 0;
	}

	@include from-lg {
		padding: 160px 0 200px;
	}

	&__message {
		font-size: 16px;
		margin-top: 30px;
	}

	p {
		max-width: none;
	}
}
</style>
